export enum InputFieldType {
    Text = 'text',
    TextArea = 'textArea',
    Number = 'number',
    Switch = 'switch',
    Dropdown = 'dropdown',
    SearchableDropdown = 'searchableDropdown',
    SearchableMultiSelectDropdown = 'SearchableMultiSelectDropdown',
    MultiSelect = 'multiSeletct',
    DatePicker = 'datePicker',
    SearchableMultiSelect = 'searchableMultiselect',
    Checkbox = 'checkbox',
    Password = 'password',
    Time = 'time',
}
